<div *ngIf="isLoading" class="loading-overlay">
    <img src="https://cdn.haitrieu.com/wp-content/uploads/2022/02/Icon-MB-Bank-MBB.png" alt="" width="50" class="spin">
    <p class="mt-3 text-white">Đang truy cập miniapp...</p>

  </div>